import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import React, { useEffect, Suspense,   } from "react";
import { ConfigProvider, message,Spin} from 'antd';
import "./App.css";
import {
  useMsal,
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
  MsalProvider
} from "@azure/msal-react";

const Status = React.lazy(() => import('./pages/Status/Status'));
const Login = React.lazy(() => import('./pages/Login/Login'));
const Home = React.lazy(() => import('./pages/Home/home'));
const RoomPage = React.lazy(() => import('./pages/RoomPage/RoomPage'));
const Loading = React.lazy(() => import('./pages/Loading/Loading'));
const Authority = React.lazy(() => import('./pages/Authority/Authority'));
const Translator = React.lazy(() => import('./pages/Translator/Translator'));
const ESGTranslation = React.lazy(() => import('./pages/ESGTranslation/ESGTranslation'));
const FaceToFace = React.lazy(() => import('./pages/FaceToFace/FaceToFace'));
const ViewPast = React.lazy(() => import('./pages/ViewPast/ViewPast'));
const Setting = React.lazy(() => import('./pages/Setting/Setting'));



import { msalInstance } from './utils/auth';
import AppConfig from "./config/index";
import RedirectHandler from "./hooks/RedirectHandler";
import { getStorage } from "./utils/utils";

const BASE_URL = AppConfig.REACT_APP_BASE_URL;

function App() {
  const [, contextHolder] = message.useMessage();
  const { accounts } = useMsal();

  useEffect(() => {
    const onBeforeunload = () => {
      if (accounts.length > 0) {
        fetch(`${BASE_URL}/logout`, {
          method: 'post',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            clientID: getStorage('idNumber'),
            token: localStorage.getItem('qxqwqsf_d7w2c6'),
          }),
          keepalive: true // this is important!
        })
      }
    }
    window.addEventListener('beforeunload', onBeforeunload)
    return () => {
      window.removeEventListener('beforeunload', onBeforeunload)
    }
  }, [])

  return (
    <>
      {contextHolder}
      <ConfigProvider
        theme={{
          components: {
            Button: {
              colorPrimary: "#3E70B3",
              algorithm: true, // 启用算法
            },
          },
        }}
      >
        <div className="App" role="main">
          <MsalProvider instance={msalInstance}>
            <BrowserRouter>
              <RedirectHandler>
                <UnauthenticatedTemplate>
                  <Suspense fallback={<div style={{display:"flex",justifyContent:"center",alignItems:"center",width:"100vw",height:"100vh",background:"#EAECF0"}}><Spin /></div>}>
                    <Routes>
                      <Route path="/login" element={<Login />} />
                      <Route path="/status" element={<Status />} />
                      <Route path="/loading" element={<Loading />} />
                      <Route path="/authority" element={<Authority />} />
                      <Route path="*" element={<Navigate to="/login" replace />} />
                    </Routes>
                  </Suspense>
                </UnauthenticatedTemplate>
                <AuthenticatedTemplate>
                  <Suspense fallback={<div style={{display:"flex",justifyContent:"center",alignItems:"center",width:"100vw",height:"100vh",background:"#EAECF0"}}><Spin /></div>}>
                    <Routes>
                      <Route path="/loading" element={<Loading />} />
                      <Route path="/Translator" element={<Translator />} />
                      <Route path="/ESGTranslation" element={<ESGTranslation />} />
                      <Route path="/face-to-face" element={<FaceToFace />} />
                      <Route path="/home" element={<Home />} />
                      <Route path="/meetingroom/:roomID" element={<RoomPage />} />
                      <Route path="/records" element={<ViewPast />} />
                      <Route path="/setting/*" element={<Setting />} />
                      <Route path="*" element={<Navigate to="/home" replace />} />
                    </Routes>
                  </Suspense>
                </AuthenticatedTemplate>
              </RedirectHandler>
            </BrowserRouter>
          </MsalProvider>
        </div>
      </ConfigProvider>
    </>
  );
}

export default App;
